const allowedTypes = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif']);
const maxBytes = 5 * 1024 * 1024;

export function validateStaffProfilePhotoFile(file: File) {
  if (!allowedTypes.has(file.type)) {
    return 'Please choose a JPEG, PNG, WebP, or GIF image.';
  }

  if (file.size > maxBytes) {
    return 'Image must be 5 MB or smaller.';
  }

  return null;
}

export function staffProfilePhotoExtension(file: File) {
  switch (file.type) {
    case 'image/png':
      return 'png';
    case 'image/webp':
      return 'webp';
    case 'image/gif':
      return 'gif';
    default:
      return 'jpg';
  }
}

export function buildStaffProfilePhotoPath(staffId: string, file: File) {
  return `staff-photos/${staffId}/profile.${staffProfilePhotoExtension(file)}`;
}
